import {
    ACTION_SET_EXPLORE_CLOSE_CLICKED,
    ACTION_SET_EXPLORE_OPEN,
    ACTION_SET_MOBILE_EXPLORE_OPEN,
    ACTION_SET_MOBILE_SEARCH_OPEN,
    ACTION_SET_SEARCH_OPEN,
    type DisplayActionTypes,
    type DisplayState,
} from '../types/display';

const DEFAULT: DisplayState = {
    exploreOpen: false,
    searchOpen: false,
    mobileSearchOpen: false,
    mobileExploreOpen: false,
    exploreCloseClicked: false,
};

export function display(state: DisplayState = DEFAULT, action: DisplayActionTypes): DisplayState {
    switch (action.type) {
        case ACTION_SET_EXPLORE_OPEN:
            return {
                ...state,
                exploreOpen: action.exploreOpen,
                searchOpen: true,
            };
        case ACTION_SET_EXPLORE_CLOSE_CLICKED:
            return { ...state, exploreCloseClicked: action.exploreCloseClicked };
        case ACTION_SET_SEARCH_OPEN:
            return { ...state, searchOpen: action.searchOpen };
        case ACTION_SET_MOBILE_EXPLORE_OPEN:
            return { ...state, mobileExploreOpen: action.mobileExploreOpen };
        case ACTION_SET_MOBILE_SEARCH_OPEN:
            return { ...state, mobileSearchOpen: action.mobileSearchOpen };

        default:
            return state ? { ...state } : DEFAULT;
    }
}
